import PrimePanel from 'primevue/panel'


const __default__ = {
  props: {
    header: {type: String, default: ''},
    pt: {type: Object, default: () => ({})}
  },
  data() {
    return {
      collapsed: false
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'panel',
  setup(__props, { expose: __expose }) {
  __expose();

const pt_default = {
  root: 'root',
  header: ['header', 'no-select'],
  title: 'title',
  toggleablecontent: 'toggleablecontent',
  toggler: 'toggler',
  content: 'content'
}

const __returned__ = { pt_default, get PrimePanel() { return PrimePanel } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})